import { cn } from '~/utils/classnames'

import { Slot } from './slot'

interface BadgeProps extends React.ComponentPropsWithRef<'div'> {
  asChild?: boolean
  interactive?: boolean
}

const TagRoot = ({
  ref,
  children,
  className,
  asChild,
  interactive,
  ...rest
}: BadgeProps) => {
  const Comp = asChild ? Slot : 'div'

  return (
    <Comp
      ref={ref}
      className={cn(
        'bg-foreground/6 text-foreground inline-flex h-8 items-center gap-2 rounded-xl px-3 text-sm leading-none font-medium',
        '[&>[data-tag-icon]:first-child]:-ml-1 [&>[data-tag-icon]:last-child]:-mr-1',
        interactive && 'hover:bg-foreground/10 cursor-pointer transition',
        className
      )}
      {...rest}
    >
      {children}
    </Comp>
  )
}

const TagIcon = ({
  children,
  className,
  ...rest
}: React.ComponentPropsWithRef<'div'>) => {
  return (
    <div
      data-tag-icon
      className={cn('flex items-center justify-center', className)}
      {...rest}
    >
      {children}
    </div>
  )
}

const Tag = Object.assign(TagRoot, {
  Icon: TagIcon,
})

export { Tag }
